//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            loading: false,
            hoverRating: null,
            activeRating: null,
            dialogVisible: false
        };
    },

    mounted () {
        this.init();
    },

    methods: {
        async init () {
            try {
                this.loading = true;
                await this.getRating();
            } catch (error) {
                this.$message({
                    type: 'error',
                    message: this.$lang.get('std.ajaxError')
                });
            } finally {
                this.loading = false;
            }
        },
        getRating () {
            return axios.get('users/rating').then(response => {
                this.activeRating = response.data.rating;
            });
        },
        async setRating (rating) {
            this.activeRating = rating;
            await this.postRating();
            this.dialogVisible = true;
        },
        postRating () {
            return axios.post('users/rating', {
                rating: this.activeRating
            });
        }
    }
};
